/* Detect Browser Language */
let browserLanguage = navigator.userLanguage || navigator.language;
browserLanguage = browserLanguage.substring(0, 2);
// browserLanguage = "pt"; // To test unmached lang from broser... fallback to english...

export default browserLanguage;


// WEBPACK FOOTER //
// ./stores/browserLanguage.js